let elements = {
  withoutReset: true,
  mainImage: {
    imagePath: 'games/page766_game3/img/bcg.jpg',
    pos: {
      x: 180,
      y: 0,
    },
    width: 1554,
    height: 1080,
  },
  withoutCheck: true,
  //imageHighlight: false,
  //imageHighlightColor: 'red',
  mbAudioItemData: [
    {
      src: 'games/page766_game3/audio/83_Easter_eggs.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page766_game3/img/audioOn.png', iconOff: 'games/page766_game3/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 820,
        x: 975,
      },
      unit: 'px',
    },
    {
      src: 'games/page766_game3/audio/84_decorate.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page766_game3/img/audioOn.png', iconOff: 'games/page766_game3/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 360,
        x: 775,
      },
      unit: 'px',
    },
    {
      src: 'games/page766_game3/audio/85_chocolate.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page766_game3/img/audioOn.png', iconOff: 'games/page766_game3/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 650,
        x: 1265,
      },
      unit: 'px',
    },
    {
      src: 'games/page766_game3/audio/86_Easter_bunny.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page766_game3/img/audioOn.png', iconOff: 'games/page766_game3/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 815,
        x: 1575,
      },
      unit: 'px',
    },
  ],
};

export default elements;
